<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div>
        <custom-tabs v-model="tabs" class="mb-2" grow>
          <template v-slot:staticTabs>
            <v-tab :ripple="false">
              <div class="cornel-left" />
              <div class="cornel-right" />
              {{ $t('change_header_color') }}
              <help-info
                :element-name="`${serviceName}-${componentName}-change-color-header`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('change_header_color')"
              />
            </v-tab>
            <v-tab :ripple="false">
              <div class="cornel-left" />
              <div class="cornel-right" />
              {{
                ["qr.product.shop", "qr.product.edit"].includes($route.name)
                  ? $t('change_button_colors')
                  : $t('change_text_colors')
              }}
              <help-info
                :element-name="`${serviceName}-${componentName}-change-color-all`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="`${
                  ['qr.product.shop', 'qr.product.edit'].includes($route.name)
                    ? $t('change_button_colors')
                    : $t('change_text_colors')
                }`"
              />
            </v-tab>
          </template>

          <template v-slot:middle>
            <v-switch
              v-if="tabs <= 1"
              v-model="gradient"
              class="py-0"
              :label="$t('gradient_colors')"
            />
          </template>

          <template v-slot:staticItems>
            <v-tab-item>
              <v-card class="rounded-lg pa-md-2" outlined>
                <v-row class="mx-auto" flat no-gutters>
                  <template v-if="gradient">
                    <v-col class="pa-2" cols="12" md="6">
                      <v-card flat max-width="200">
                        <div class="rowinfo">
                          <v-autocomplete
                            v-model="gradientColor.dir"
                            :items="direction"
                            dense
                            hide-details
                            item-text="text"
                            item-value="value"
                            :label="$t('color_direction')"
                            outlined
                            class="contentinfo"
                          />
                          <help-info
                            :element-name="`${serviceName}-${componentName}-gradientColor-dir`"
                            :service-name="serviceName"
                            :help-data="helpData"
                            class="buttoninfo"
                            :label="$t('color_direction')"
                          />
                        </div>
                      </v-card>
                    </v-col>

                    <v-col class="pa-2 d-none d-md-block" cols="12" md="6" />

                    <v-col class="pa-2" cols="12" md="6">
                      <color-picker
                        v-model="gradientColor.color1"
                        :label="$t('first_color')"
                      />
                    </v-col>

                    <v-col class="pa-2" cols="12" md="6">
                      <color-picker
                        v-model="gradientColor.color2"
                        :label="$t('second_color')"
                      />
                    </v-col>
                  </template>

                  <v-col v-else class="pa-2" cols="12" md="6">
                    <color-picker v-model="colorObj.headColor" :label="$t('color')" />
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card class="rounded-lg pa-md-2" outlined>
                <v-row no-gutters>
                  <v-col class="pa-2" cols="12" md="6">
                    <color-picker
                      v-model="colorObj.textColor"
                      :label="$t('text_color')"
                    />
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </template>
        </custom-tabs>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import { Bus } from "../../../../../main";
import ColorPicker from "../../../qrland/components/colorPicker.vue";
import HelpInfo from "../../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../../qrland/components/helpAcordion/HelpInfoWrapper.vue";

export default {
  name: "colorPallete",

  components: { ColorPicker, HelpInfo, HelpInfoWrapper },

  props: {
    value: Object,
    data: [Object, Array],
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "colorpallete",
      tabs: 0,
      colorObj: {
        headColor: "linear-gradient(to right , #D81A1AFF, #2115A7FF)",
        bodyColor: "linear-gradient(to top left , #D81A1AFF, #2115A7FF)",
        textColor: "#FFFFFF",
      },
      headGrad: "",
      gradientColor: {
        dir: "to right",
        color1: "#D81A1AFF",
        color2: "#2115A7FF",
      },
      body: {
        dir: "to top left",
        color1: "#D81A1AFF",
        color2: "#2115A7FF",
      },
      direction: [
        { text: this.$t('from_top'), value: "to top" },
        { text: this.$t('from_bottom'), value: "to bottom" },
        { text: this.$t('from_left_to_right'), value: "to right" },
        { text: this.$t('from_right_to_left'), value: "to left" },
        { text: this.$t('from_top_to_left'), value: "to top left" },
        { text: this.$t('from_top_to_right'), value: "to top right" },
        { text: this.$t('from_bottom_to_left'), value: "to bottom left" },
        { text: this.$t('from_bottom_to_right'), value: "to bottom right" },
      ],
      gradient: true,
      borderChange: false,
      borderColor: "",
      changeTexts: false,
    };
  },

  mounted() {
    this.setColors();
  },

  computed: {
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    value(val) {
      this.setColors();
    },
    colorObj: {
      handler(value) {
        this.valueComputed = value;
        Bus.$emit("colorUpdate", value);
      },
      deep: true,
    },
    gradient: {
      handler(value) {
        Bus.$emit("gradientType", value);

        let obj = this.value;
        if (!value) {
          this.colorObj.headColor = obj.headColor = this.gradientColor.color1;
          this.colorObj.bodyColor = obj.bodyColor = this.gradientColor.color2;
        } else {
          this.colorObj.headColor =
            obj.bodyColor = `linear-gradient(${this.gradientColor.dir} , ${this.gradientColor.color1}, ${this.gradientColor.color2})`;
          this.colorObj.bodyColor =
            obj.bodyColor = `linear-gradient(${this.body.dir} , ${this.body.color1}, ${this.body.color2})`;
        }

        this.$emit("input", obj);
      },
      deep: true,
    },
    body: {
      handler(value) {
        let obj = this.value;
        this.colorObj.headColor =
          obj.headColor = `linear-gradient(${this.gradientColor.dir} , ${this.gradientColor.color1}, ${this.gradientColor.color2})`;
        this.colorObj.bodyColor =
          obj.bodyColor = `linear-gradient(${this.body.dir} , ${this.body.color1}, ${this.body.color2})`;

        this.$emit("input", obj);
        Bus.$emit("bodyColor", value);
      },
      deep: true,
    },
    gradientColor: {
      handler(value) {
        let obj = this.value;
        this.colorObj.headColor =
          obj.headColor = `linear-gradient(${this.gradientColor.dir} , ${this.gradientColor.color1}, ${this.gradientColor.color2})`;
        this.colorObj.bodyColor =
          obj.bodyColor = `linear-gradient(${this.body.dir} , ${this.body.color1}, ${this.body.color2})`;

        this.$emit("input", obj);
        Bus.$emit("headColor", value);
      },
      deep: true,
    },
    borderColor: {
      handler(value) {
        this.$emit("input", value);
        Bus.$emit("bordersColor", value);
      },
      deep: true,
    },
  },

  methods: {
    setColors() {
      if (this.value) {
        this.colorObj = this.value;
        if (this.value.headColor) {
          let arr = this.value.headColor.match(/(\#.+)\)/)[1];
          arr = arr.split(", ");
          this.gradientColor.color1 = arr[0];
          this.gradientColor.color2 = arr[1];
        }

        if (this.value.bodyColor) {
          let arr = this.value.bodyColor.match(/(\#.+)\)/)[1];
          arr = arr.split(", ");
          this.body.color1 = arr[0];
          this.body.color2 = arr[1];
        }
      } else {
        this.colorObj = {
          headColor: "linear-gradient(to right , #D81A1AFF, #2115A7FF)",
          bodyColor: "linear-gradient(to bottom left , #170000, #FF0000)",
          textColor: "#ffffff",
          borderColor: "#393939",
        };

        // this.gradientColor.color1 = '#D81A1AFF'
        // this.gradientColor.color2 = '#2115A7FF'
        // this.body.color1 = '#170000'
        // this.body.color2 = '#FF0000'
      }
    },
  },
};
</script>

<style scoped>
.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}

.sp-wrapper {
  padding: 12px 0;
  border-bottom: 1px dashed rgb(126, 130, 153);
}
</style>
